<template>
    <v-container fluid>
        <v-card>
            <v-card-title>
                Post Term Reports
                <v-spacer></v-spacer>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details                     
                ></v-text-field>
            </v-card-title>
            
            <v-data-table
                :headers="headers"
                :items="terms"
                :search="search"
                :loading="loading"
                loading-text="Loading... Please wait"
                fixed-header
                height="60vh" 
            >
                <template
                    v-slot:top
                >
                    <v-dialog
                        v-model="dialog"
                        max-width="550px"
                        persistent
                    >
                        <v-card
                            v-show="cardPostReport"
                        >
                            <v-card-title>
                                {{ formText }}
                            </v-card-title>

                            <v-card-text>
                                <v-data-table
                                    :headers="headersFormLevels"
                                    :items="formLevels"
                                    hide-default-footer
                                >
                                    <template v-slot:[`item.actions`]="{ item }">
                                        <v-switch
                                            v-model="item.posted"
                                            inset
                                            @change="postReports(item)"
                                        >                                        
                                        </v-switch>
                                    </template> 
                                    
                                    <template v-slot:[`item.status`]="{ item }">
                                        <div v-if="item.status=='posting'">
                                            <v-progress-circular
                                                indeterminate
                                                size="24"
                                                class="mr-3"
                                            ></v-progress-circular> 
                                            Posting...
                                        </div>
                                        <v-chip
                                            v-if="item.status != 'posting'"
                                            :color="item.status ? 'green' : 'red'"
                                            dark
                                            small
                                        >
                                            {{ item.posted ? 'Reports Posted' : 'Reports Not Posted' }}
                                        </v-chip>
                                    </template>
                                </v-data-table>    
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    depressed
                                    @click="cancel"
                                    class="mr-4"
                                >
                                    Close
                                </v-btn>
                                
                                <v-btn
                                    color="primary"
                                    @click="postReports({ posted: 1, value: null })"
                                    class="mr-4"
                                >
                                    Post All
                                </v-btn>
                            </v-card-actions>

                            <v-overlay 
                                :value="overlay" 
                                absolute
                                color="#000"
                                opacity="0.6"
                            >
                                <v-progress-circular
                                    indeterminate
                                    size="64"
                                ></v-progress-circular>
                            </v-overlay>
                        </v-card>

                        <v-expand-transition>
                            <v-card
                                color="primary"
                                dark
                                v-show="expand"
                                class="pa-4"
                            >
                                <v-card-text>
                                    {{ postingText }}
                                <v-progress-linear
                                    indeterminate
                                    color="white"
                                    class="mb-0 mt-2"
                                ></v-progress-linear>
                                </v-card-text>
                            </v-card>
                        </v-expand-transition>
                    </v-dialog>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                    <v-btn
                        color="primary"
                        @click="editTerm(item)"
                        small
                    >
                        <v-icon
                            small
                            class="mr-2"
                        >
                            mdi-pencil
                        </v-icon>
                        Edit
                    </v-btn>
                </template>


            </v-data-table>
            
        </v-card>
        <v-snackbar
            v-model="snackbar"
            color="primary"
        >
            {{ snackText }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    color="white"
                    text
                    v-bind="attrs"
                    @click="snackbar = false"
                >
                    Close
                </v-btn>
            </template>
        </v-snackbar>
    </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
export default {
    data: () => ({
        headers:[
            {
                text: 'Academic Year',
                align: 'center',
                value: 'academic_year'
            },
            {
                text: 'Term',
                align: 'center',
                value: 'term'
            },
            {
                text: 'Posted',
                align: 'center',
                value: 'posted'
            },
            {
                text: 'Edit',
                align: 'center',
                value: 'actions',
                sortable: false,
            },
        ],
        headersFormLevels: [
            { text: 'Form', value: 'form_level', width: '100px', sortable: false },
            { text: 'Actions', value: 'actions', width: '80px', sortable: false },
            { text: 'Status', value: 'status', sortable: false },
            { text: 'Date Posted', value: 'date_posted', width: '150px', sortable: false },
        ],
        formLevels: [
            { form_level: 'Form 1', value: 1, posted: 0, status: '', date_posted: '' },
            { form_level: 'Form 2', value: 2, posted: 0, status: '', date_posted: '' },
            { form_level: 'Form 3', value: 3, posted: 0, status: '', date_posted: '' },
            { form_level: 'Form 4', value: 4, posted: 0, status: '', date_posted: '' },
            { form_level: 'Form 5', value: 5, posted: 0, status: '', date_posted: '' },
            { form_level: 'Form 6', value: 6, posted: 0, status: '', date_posted: '' },
        ],
        terms: [],
        search: '',
        loading: true,
        dialog: false,
        editedItem: {},
        snackbar: false,
        snackText: '',
        cardPostReport: true,
        expand: false,
        postingText: '',
        overlay: false,
    }),

    created(){
        //console.log('post term reports created');
        this.initialize();
    },

    computed: {
        ...mapGetters({
            menuOptions: 'admin/getMenuOptions',
        }),
        formText () {
            return `${this.editedItem.academic_year} Term ${this.editedItem.term} Reports`;
        },
    },

    methods: {
        ...mapActions({
            getTermReportsPosted: 'admin/getReportsPosted',
            postTermReports: 'admin/postTermReports',
            getTermReportsPostedByFormLevel: 'admin/getTermReportsPostedByFormLevel',
        }),
        ...mapMutations({
            setEditedTerm: 'admin/setEditedTerm',
            setSelectedTermReportPostedYearTerm: 'admin/setSelectedTermReportPostedYearTerm',
        }),
        async initialize(){
            this.loading = true;
            this.terms = [];
            try {
                const { data } = await this.getTermReportsPosted();
                data.forEach( record => {
                    let posted = Object.entries(record.posted)
                    .filter(([, value]) => value === 1)
                    .map(([key]) => `Form ${key}` )
                    .join(', ')

                    if(Object.values(record.posted).every(value => value === 1)){
                        posted = 'All Forms Posted';
                    }

                    this.terms.push({
                        year: record.year,
                        academic_year: record.year + '-' + (parseInt(record.year) + 1),
                        term: record.term,
                        posted 

                    })
                })

                this.loading = false;
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
            }
        },
       
        editTerm(item){
            this.setSelectedTermReportPostedYearTerm({ year: item.year, term: item.term });
            this.editedItem = item;
            this.cardPostReport = true;
            this.dialog = true;
            this.fetchTermReportsPosted();           
        },

        async fetchTermReportsPosted(){
            this.overlay = true;
            try {
                const { data } = await this.getTermReportsPostedByFormLevel();
                this.mapFormLevelsPosted(data);
            } catch (error) {
                error.response ? console.log(error.response) : console.log(error);
            }
            this.overlay = false;
        },

        mapFormLevelsPosted(data)
        {
            this.formLevels.forEach( formLevel => {
                const match = data.find(l => l.form_level == formLevel.value);
                if(!match) return;

                if(match  && !match?.date_posted){
                    formLevel.posted = match.posted;
                    formLevel.date_posted = null;
                    formLevel.status = match.posted;
                    return;
                }
                
                const date = new Date(match.date_posted.replace(' ', 'T'));
                const formatted = date.toLocaleString("en-US", {
                    year: 'numeric',
                    month: 'short',
                    day: '2-digit',
                    hour: 'numeric',
                    minute: '2-digit',
                    second: '2-digit',
                    hour12: true
                });
                
                formLevel.posted = match.posted;
                formLevel.date_posted = match.posted ? formatted : null;
                formLevel.status = match.posted;
                
            })
        },

        cancel(){
            this.dialog = false;
        },
        
        async postReports(item){
            if(item.value == null) this.overlay = true;
            let termRecord = Object.assign({}, this.editedItem);
            termRecord['posted'] = item.posted ? 1 : 0;
            termRecord['form_level'] = item.value;
            let date = new Date();
            termRecord['date_posted'] = date.toLocaleString("sv-SE");
            // console.log(termRecord);
            this.setEditedTerm(termRecord);  
            item.status = 'posting';          
            try {
                const { data, statusText }  = await this.postTermReports();
                console.log(statusText);
                item.status = item.posted ? 1 : 0;

                const date = new Date(data.date_posted.replace(' ', 'T'));
                const formatted = date.toLocaleString("en-US", {
                    year: 'numeric',
                    month: 'short',
                    day: '2-digit',
                    hour: 'numeric',
                    minute: '2-digit',
                    second: '2-digit',
                    hour12: true
                });

                item.date_posted = formatted;

                if(item.posted == 0) item.date_posted = '';
                this.fetchTermReportsPosted();
                this.initialize();

            } catch (error) {
                error.response ? console.log(error.response) : console.log(error);
                item.status = 'error';
            }
            this.overlay = false;
        },
        
    }
}
</script>

<style scoped>  
    ::v-deep .v-data-table td{
        table-layout: fixed;
    }
</style>